import { defineStore } from 'pinia';
import { useApiStore } from './API.module';

export const usePartnersStore = defineStore('partners', {
  state: () => ({
    partners: [],
    suppliers: [],
    services: [],
    dealers: [],
    terminals: []
  }),
  actions: {
    async getPartners() {
      try {
        this.partners = await useApiStore().send({
          method: 'post',
          requestURL: '/partners/all',
          requestData: {},
        });
      } catch {
        this.partners = [];
      }
    },
    async searchPartners(name) {
      try {
        this.partners = await useApiStore().send({
          method: 'post',
          requestURL: '/partners/all',
          requestData: { name: name || undefined },
        });
      } catch {
        this.partners = [];
      }
    },
    async getLists() {
      await this.getTerminals(null);
      await this.getServices(null);
    },
    async getDealers(name) {
      try {
        this.dealers = await useApiStore().send({
          method: 'post',
          requestURL: '/partners/getdealers',
          requestData: { name: name || undefined }
        });
      } catch {
        this.dealers = [];
      }
    },
    async getDealerList() {
      try {
        this.dealers = await useApiStore().send({
          method: 'post',
          requestURL: '/partners',
          requestData: { type: 'Дилер' },
        });
      } catch {
        this.dealers = [];
      }
    },
    async updateDealer({ name, info, partnerId }) {
      await useApiStore().send({
        method: 'put',
        requestURL: '/partners/update',
        requestData: { name, info, partnerId },
      });
    },
    async getSuppliers(name) {
      try {
        this.suppliers = await useApiStore().send({
          method: 'post',
          requestURL: '/partners/getsuppliers',
          requestData: { name: name || undefined }
        });
      } catch {
        this.suppliers = [];
      }
    },
    async getTerminals(dealer) {
      if (dealer) {
        try {
          this.terminals = await useApiStore().send({
            method: 'post',
            requestURL: '/terminals',
            requestData: { dealerId: dealer.id }
          });
        } catch {
          this.terminals = [];
        }
      } else {
        this.terminals = [];
      }
    },
    async toggleService({ serviceId, status }) {
      await useApiStore().send({
        method: 'post',
        requestURL: '/services/toggle',
        requestData: { serviceId, status },
      });
    },
    async getDealerServices(dealer) {
      if (dealer) {
        try {
          this.services = await useApiStore().send({
            method: 'post',
            requestURL: '/services/dealerservices',
            requestData: { partnerId: dealer.id }
          });
        } catch {
          this.services = [];
        }
      } else {
        this.services = [];
      }
    },
    async getServices(supplier) {
      if (supplier) {
        try {
          this.services = await useApiStore().send({
            method: 'post',
            requestURL: '/services',
            requestData: { supplierId: supplier.id }
          });
        } catch {
          this.services = [];
        }
      } else {
        this.services = [];
      }
    }
  }
});
